import React from 'react';
import { Input, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { debounce } from 'lodash';
import { SearchIcon, CrossIcon } from '../../../custom_shared/icons';
import { ClickableIcon } from '../../../common/components';
import { DocumentPreviewStore } from '../../stores';
import { getIconSize } from '../../../documents/config/iconSizes';
import './TextSearch.less';

const searchLabel = 'Search';

interface Props {
    variant: 'outlined' | 'filled';
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
}

const TextSearch: React.FC<Props> = ({ variant, documentPreviewStore, lightMode }) => {
    const inputRef = React.useRef<Input>(null);
    const iconSize = getIconSize('previewControls', lightMode);

    const debouncedSearch = React.useMemo(
        () =>
            debounce(() => {
                documentPreviewStore.searchPackageFields();
            }, 500),
        [documentPreviewStore]
    );

    React.useEffect(() => {
        debouncedSearch();
    }, [documentPreviewStore, documentPreviewStore.searchTerm, debouncedSearch]);

    React.useEffect(() => {
        if (documentPreviewStore.searchInputVisible && inputRef.current) {
            inputRef.current.focus();
        }
    }, [documentPreviewStore.searchInputVisible]);

    if (!documentPreviewStore.searchInputVisible) {
        return (
            <Tooltip title={searchLabel}>
                <ClickableIcon
                    width={iconSize}
                    height={iconSize}
                    icon={SearchIcon}
                    onClick={() => documentPreviewStore.setSearchInputVisible(true)}
                />
            </Tooltip>
        );
    }

    return (
        <div className={`custom-app-text-search-container ${variant}`} onClick={e => e.stopPropagation()}>
            <SearchIcon />
            <Input
                ref={inputRef}
                placeholder={searchLabel}
                value={documentPreviewStore.searchTerm}
                onChange={e => documentPreviewStore.setSearchTerm(e.target.value)}
            />
            <CrossIcon onClick={() => documentPreviewStore.setSearchInputVisible(false)} />
        </div>
    );
};

export default observer(TextSearch);
